import React, { Component } from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import config from '../config';

class TwoFactorAuth extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: props.email,
            partialLoginToken: props.partialLoginToken,
            options: props.options,
            selectedOption: '',
            redirectURL: props.redirectURL,
            errorMessage: '',
            subDomain:props.subDomain
        };
        this.handleOptionChange = this.handleOptionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleOptionChange(event) {
        this.setState({ selectedOption: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        const { partialLoginToken, selectedOption, redirectURL ,subDomain} = this.state;
        const email = this.props.email;
        const option = selectedOption.split(':')[0].trim().toLowerCase();
        axios.post(config.partialLogin, {
            partialLoginToken,
            email,
            option: option
        })
        .then(response => {
            this.props.history.push({
                pathname: '/otp',
                state: { _email: email, partialLoginToken, redirectURL,subDomain }
            });
        })
        .catch(error => {
            if (error.response && error.response.data && error.response.data.message) {
                this.setState({ errorMessage: error.response.data.message });
            } else {
                this.setState({ errorMessage: 'An error occurred while verifying login.' });
            }
        });
    }

    handleBackClick = () => {
        window.location.replace(this.state.redirectURL);
    };

    render() {
        const { options, selectedOption, errorMessage } = this.state;

        const optionStyle = {
            marginBottom: '1rem'
        };

        const backLinkStyle = {
            display: 'block',
            textAlign: 'center',
            cursor: 'pointer',
            color: '#007bff',
            marginTop: '1rem'
        };

        const errorStyle = {
            color: 'red'
        };

        return (
            <div className="container">
                <div className="card card-login mx-auto mt-5">
                    <div className="login-logo"></div>
                    <div className="login-header text-center">Welcome</div>
                    <div className="card-body">
                        <div className="text-center mb-4 lightgray">Select OTP delivery method.</div>
                        
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group">
                                {options.map((option, index) => (
                                    <div className="custom-control custom-radio" style={optionStyle} key={index}>
                                        <input
                                            type="radio"
                                            id={`option${index}`}
                                            name="otpOption"
                                            value={option.value}
                                            checked={selectedOption === option.value}
                                            onChange={this.handleOptionChange}
                                            className="custom-control-input"
                                        />
                                        <label className="custom-control-label" htmlFor={`option${index}`}>
                                            {option.value}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            {errorMessage && <div style={errorStyle}>{errorMessage}</div>}
                            <button type="submit" className="btn btn-primary btn-block" disabled={!selectedOption}>Continue</button>
                        </form>
                        <div style={backLinkStyle} onClick={this.handleBackClick}>Back</div>
                    </div>
                    <div className="login-footer">
                        &copy; 2024 Reliance Industries Limited. All rights reserved.
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(TwoFactorAuth);




// WEBPACK FOOTER //
// ./src/components/TwoFactorAuth.js